import { FilterProps } from "../filter-definition";
import { RADIO_BUTTON_FUTURE_OPTIONS } from "../filterConstants";
import { RadioButtonDateFilter } from "../GenericFilters/RadioButtonDateFilter";

export const InvoicesDueDateFilter = (props: FilterProps) => (
  <RadioButtonDateFilter
    {...props}
    filterKey="dueDate"
    name="Due Date"
    filterOptions={RADIO_BUTTON_FUTURE_OPTIONS}
  />
);
